import { useState } from 'react';
import { OKCancel } from '../../lib/iprs-react-library/src/index.js';

const PhysitrackSettings = ({ state }) => {

    const [apiKey, setAPIKey] = useState('');
    const [error, setError] = useState('');

    const { api } = state;

    const onOK = e => {

        api.transact("SetupClinicianForPhysitrack", { ClinicianPhysitrackAPIKey: apiKey })
            .then(r => { setError('Your key has been set') })
            .catch(e => setError(e.apiText) )
    }

    return <form>

        <h3>{'Add your Physitrack API key'}</h3>
        <p>{'You can get this key from the settings in your Physitrack account'}</p>

        <label htmlfor='apiKey' ></label>
        <input id='apiKey' name='apiKey' value={apiKey} onChange={e => setAPIKey(e.target.value)}
            placeholder='Enter your API key from Physitrack' type='password' />

        <OKCancel onOK={onOK} onCancel={e => { }} />
        <p>{error}</p>
    </form>
};

export default PhysitrackSettings;

